import React, { useEffect, useState } from "react";
import {
  Box,
  Stack,
  Dialog,
  AppBar,
  Toolbar,
  IconButton,
  Button,
  Slide,
  List,
  ListItemText,
  Divider,
  styled,
  Typography as MuiTypography,
  Grid,
  Modal,
  Chip,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { TransitionProps } from "@mui/material/transitions";
import ProjectList, { Project } from "./ProjectList";
import projectDataList from "../../utils/ongoingProjects.json";
import { toast } from "react-toastify";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import Close from "@mui/icons-material/Close";
import { wrap } from "module";

type Props = {};

const Typography = styled(MuiTypography)<{ component?: React.ElementType }>(
  ({ theme }) => ({
    fontSize: 16,
  })
);

const YearList = [
  {
    year: "2025-2026",
    subtabs: [
      {
        title: "FINAL YEAR",
      },
      {
        title: "INTERNS",
      },
      {
        title: "POST-GRADUATES",
      },
    ],
  },
  {
    year: "2024-2025",
    subtabs: [
      {
        title: "FINAL YEAR",
      },
      {
        title: "INTERNS",
      },
      {
        title: "POST-GRADUATES",
      },
    ],
  },
  {
    year: "2023-2024",
    subtabs: [
      {
        title: "FINAL YEAR",
      },
      {
        title: "INTERNS",
      },
      {
        title: "POST-GRADUATES",
      },
    ],
  },
  {
    year: "2022-2023",
    subtabs: [
      {
        title: "FINAL YEAR",
      },
      {
        title: "INTERNS",
      },
      {
        title: "POST-GRADUATES",
      },
    ],
  },
  {
    year: "2021-2022",
    subtabs: [
      {
        title: "FINAL YEAR",
      },
      {
        title: "INTERNS",
      },
      {
        title: "POST-GRADUATES",
      },
    ],
  },
  {
    year: "2020-2021",
    subtabs: [
      {
        title: "FINAL YEAR",
      },
      {
        title: "INTERNS",
      },
      {
        title: "POST-GRADUATES",
      },
    ],
  },
  {
    year: "2019-2020",
    subtabs: [
      {
        title: "FINAL YEAR",
      },
      {
        title: "INTERNS",
      },
      {
        title: "POST-GRADUATES",
      },
    ],
  },
];

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function OngoingResearchProjects({}: Props) {
  const [selectedYear, setSelectedYear] = useState<string | null>(null);
  const [open, setOpen] = useState(false);
  const [selectedSubtab, setSelectedSubtab] = useState<string | null>(null);
  const [projects, setProjects] = useState<Project[]>([]);

  const handleYearClick = (year: string) => {
    if (selectedYear === year) {
      setSelectedYear(null);
    } else {
      setSelectedYear(year);
    }
  };

  const handleSubtabClick = (subtabTitle: string) => {
    setSelectedSubtab(subtabTitle);
  };

  const handleClose = () => {
    setSelectedSubtab(null);
    setProjects([]);
    setOpen(false);
  };

  function Subtabs(tabDetails: { title: string }) {
    return (
      <Grid item key={tabDetails?.title} xs="auto" sx={{ my: 1 }}>
        <Chip
          label={tabDetails?.title}
          variant="filled"
          sx={{
            color:
              tabDetails?.title === selectedSubtab ? "secondary.main" : "white",
            backgroundColor:
              tabDetails?.title === selectedSubtab
                ? "transparent"
                : "secondary.main",
            cursor: "pointer",
            border: "2px solid",
            padding: "8px 16px",
            borderRadius: "16px",
            textTransform: "uppercase",
            fontWeight: "bold",
            transition: "all 0.3s ease-in-out",
            "&:hover": {
              opacity: 0.8,
              color: "inherit",
              backgroundColor: "transparent",
              border: "2px solid",
              borderColor: "secondary.main",
              "& .MuiChip-label": {
                textDecoration: "underline",
              },
            },
            "&:active": {
              transform: "scale(0.95)",
            },
          }}
          onClick={() => handleSubtabClick(tabDetails?.title)}
        />
      </Grid>
    );
  }

  useEffect(() => {
    const selectedYearData = projectDataList.find(
      (item) => item.year === selectedYear
    );

    let projectList: Project[] = [];

    if (selectedYearData) {
      if (selectedSubtab === "FINAL YEAR") {
        projectList = selectedYearData["FINAL YEAR"] || [];
      } else if (selectedSubtab === "INTERNS") {
        projectList = selectedYearData.INTERNS;
      } else if (selectedSubtab === "POST-GRADUATES") {
        projectList = selectedYearData["POST-GRADUATES"];
      }
    }

    setProjects(projectList);
    // if (projectList.length > 0) {
    selectedYear && selectedSubtab && setOpen(true);
    // } else {
    //   selectedYear && selectedSubtab && toast("No data available!");
    //   setSelectedSubtab(null);
    // }
  }, [selectedYear, selectedSubtab]);

  return (
    <Box
      sx={{
        backgroundColor: "primary.light",
        p: { xs: 1, md: 3 },
        width: "90vw",
      }}
      m={2}
    >
      <Stack
        direction="column"
        alignItems="flex-start"
        justifyContent="center"
        sx={{ border: "1px solid #e0e0e0", p: { xs: 1, md: 3 } }}
        spacing={2}
      >
        {YearList?.map((item, idx) => (
          <Box key={idx} sx={{ width: "100%" }}>
            <Grid container alignItems={"center"}>
              <Grid
                sx={{
                  fontSize: 24,
                  transform: `rotate(${
                    item.year === selectedYear ? 90 : 0
                  }deg)`,
                }}
              >
                <ArrowForwardIosIcon />
              </Grid>
              <Grid>
                <Typography
                  onClick={() => handleYearClick(item.year)}
                  sx={{
                    display: "block",
                    cursor: "pointer",
                    fontWeight: "bold",
                    textDecoration: "none",
                    "&:hover": {
                      textDecoration: "underline",
                      color: "primary.main",
                    },
                    ml: 1,
                  }}
                >
                  {item.year}
                </Typography>
              </Grid>
            </Grid>
            {selectedYear === item.year && item.subtabs.length > 0 && (
              <Stack
                direction="row"
                spacing={{ xs: 0, sm: 2 }}
                sx={{ pl: 3 }}
                flexWrap={"wrap"}
                justifyContent={"left"}
              >
                {item.subtabs.map((subtab, subIdx) => (
                  <>
                    <Box p={1}>{Subtabs(subtab)}</Box>
                  </>
                ))}
              </Stack>
            )}
          </Box>
        ))}
      </Stack>

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{
          zIndex: (theme) => theme.zIndex.modal + 15,
        }}
      >
        <Box
          sx={{
            position: "absolute",
            width: "96%",
            height: "90%",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            borderRadius: "10px",
            boxShadow: 24,
            overflow: "auto",
          }}
        >
          <Grid container p={2}>
            <Grid item xs={12} textAlign={"center"}>
              <Typography
                sx={{ ml: 2, flex: 1, fontWeight: "bold" }}
                variant="h4"
              >
                {selectedSubtab} PROJECTS - {selectedYear}
              </Typography>
              <IconButton
                sx={{
                  position: "absolute",
                  top: "0px",
                  right: "0px",
                  zIndex: (theme) => theme.zIndex.modal + 15,
                }}
                onClick={handleClose}
              >
                <Close />
              </IconButton>
              <Divider sx={{ m: 1 }} />
            </Grid>
            <Grid item xs={12} borderRadius={"10px"}>
              <List sx={{ textAlign: "center" }}>
                <ListItemText
                  style={{
                    // background: "#000",
                    padding: "4px 0px",
                  }}
                >
                  {`Total no. of ${selectedSubtab} Projects :  ${projects.length}`}
                </ListItemText>
              </List>
              <Divider />

              {/* <img src={src} alt="Admission Popup" width="100%" height="100%" /> */}
            </Grid>
            <Grid item xs={12}>
              <List>
                <ProjectList projects={projects} />
              </List>
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </Box>
  );
}

export default OngoingResearchProjects;
